const READY = 'ready';
const LOADING = 'loading';
const ERROR = 'error';

export const STATUSES = {
  READY,
  LOADING,
  ERROR,
};
